import * as catalogos from './catalogos/pt';
export const locale = {
  lang: 'pt',
  data: {
    'RESPONDE': catalogos.answer,
    'CONSULTATABLA': {
      'TITULO': 'Consulta geral',
      'HEADER': 'Empresas:',
      'BUSCAR': 'Pesquisar empresa',
      'BUSCAR_PLACEH': 'Digite o nome da empresa que deseja pesquisar',
      'EMPRESA': 'EMPRESA',
      'MESSAGE3':'<span> Se você tiver certeza de que deseja fazer uma eliminação lógica do produto, digite o texto em vermelho na caixa de texto:',
      'MESSAGE4':'</span>',
      'CANCELAR': 'Cancelar',
      'COMFIR': 'Confirme',
      'PROC_DELE_PROD':'Remoção do produto',
      'SUCC_DELE_PROD':'O produto foi removido com sucesso',
      'DELE_PRODU':'Eliminar produto',
      'TEX_VERS_RESULT_OPC1':'Versão por defeito',
      'TEX_VERS_RESULT_OPC2':'Versão personalizada',
      'TEX_VERS_RESULT_LAB':'Versão personalizada',
      'TEX_PLAC_RESULT_LAB':'Introduzir versão personalizada',
      'TEX_MOD_RESULT_VERS':'É necessário introduzir o tipo de versão do resultado',
      'SELECT_PLANTILLA': 'Seleccione um modelo',
      'SELECT_EMAIL_PLANTILLA': 'Seleccione um modelo de comunicação',
      'ACCION': 'ACÇÃO',
      'CREAT_DATE_EMP': 'Data de criação',
      'TYP_REGISTR_EMP': 'Tipo de registo',
      'AUTOR_EMP': 'Autor',
      'DETALLE': 'Produtos',
      'MANAGER_TI': 'Gestor de TI',
      'STATUS':'Status da pesquisa',
      'EMA_HISTO': 'História do correio',
      'LABEL1': 'Detalhes da empresa',
      'DESCDETAIL': 'Os formulários reactivos angulares facilitam um estilo de programação reactiva que favorece a gestão explícita do fluxo de dados entre um modelo de dados sem uma interface de utilizador (normalmente recupe',
      'DETAIL': 'Detalhe',
      'SECTOR': 'Sector:',
      'SUBSECTOR': 'Sub-sector:',
      'RANKING': 'Classificação:',
      'SELECCIONE_FECHA': 'Data',
      'SELECT_CSSID': 'Ano de aplicação',
      'SELECT_CSSIDR': 'Ano de classificação',
      'TIPORANKING': 'Tipo de classificação ',
      'TIP_PRODU': 'Tipo de produto',
      'TIP_PLAN_PRO': 'Nome do modelo',
      'TIP_DIS_PRO': 'Design',
      'SELECT_CSSID2': 'Seleccione um desenho',
      'SURVEYTK_TITU': 'Chave do inquérito',
      'SURVEYTK_DESC': 'Introduza a chave do inquérito para este produto',
      'TABLEAUVER_TITU': 'Versão de resultados',
      'TABLEAUVER_DESC': 'Introduzir a versão do sistema de resultados para este produto',
      'IDOPORTUNITY': 'Id de oportunidade (Sales Force)',
      'NAMEOPORTUNITY': 'Nome da oportunidade(Sales Force)',
      'IDTYPERESULT': 'tipos de resultados',
      'NAM_USE_SWIFT':'Nome de utilizador',
      'TO_USE_SWIFT': 'Número total de colaboradores',
      'EMA_USE_SWIFT': 'E-mail do utilizador',
      'PASS_USE_SWIFT': 'Palavra-passe do utilizador',
      'CAT_RES':{
        '1': 'Resultados completos',
        '2': 'Resultados básicos',
      },
      'PROYECTMANAGER': 'Gestor de projeto',
      'PROYECTMANAGER_MAIL': 'Email do gerente de projeto',
      'CONFIGURE': 'clique aqui para configurar',
      'TIPO': 'Tipo:',
      'Reactivos': 'Reagentes',
      'NPS': 'NPS',
      'Demograficos': 'Demográficos',
      'Forall': 'Forall',
      'Adicionales': 'Adicional',
      'Control': 'Controlo',
      'Abiertas': 'Aberto',
      'URL':'Ligação',
      '0': 'Desenho de Ícones Brancos',
      '1': 'Desenho de Ícones Amarelos',
      '4': 'Círculos de Design de Ícone',
      'ADDPRODUCTS': 'Adicionar produtos',
      'ADD': 'Acrescentar',
      'NAME_SURVEY':'Nome da pesquisa:',
      'UPDATE_NAME_SURVEY':'Atualizando o nome ',
      'LABELCONTRATADOS': 'Produtos em uso:',
      'PRODUCTOS': catalogos.productos,
      'PRODUCTOSTURQUIA': catalogos.productosTurquia,
      'CATEGORIAS': catalogos.categorias,
      'GETLISTAEMP': 'Lista de carga de empresas registadas',
      'EDITAR': 'Editar dados da empresa',
      'LOGIN': 'Login',
      'PAGINATOR_1': 'a partir de',
      'PAGINATOR_2': 'empresas',
      'TIMELINE': 'Linha temporal de R.T.',
      'PAQUETES': 'Pacotes',
      'ELIMINAR': 'Excluir empresa',
      'CORREOMODIF': 'Este produto possui alterações no corpo do email',
      'CORREOMODIFMODAL': 'Há novas alterações por email pendentes de validação em um ou mais produtos. Por favor, verifique-os',
      'CORREOMODAL_2': 'Novas mudanças de e-mail estão atualmente pendentes de validação',
      'MODIFBTN': 'Configurações do produto',
      'INF_BTN': 'Informações sobre o produto',
      'INF_PROD_SEL': 'Informações sobre o produto',
      'VALIDMAIL_1': 'Validar alterações',
      'VALIDMAIL_2': 'Email validado',
      'VALIDMAIL_3': 'Deseja validar as alterações feitas na mensagem?',
      'VALIDMAIL_4': 'As alterações no email foram validadas corretamente',
      'VALIDMAIL_5': 'Rejeitar alterações',
      'VALIDMAIL_6': 'Deseja rejeitar as alterações feitas na mensagem?',
      'VALIDMAIL_7': 'As alterações no corpo do email foram rejeitadas. O modelo de email padrão será usado no lugar',
      'VALIDMAIL_8': 'E-mail rejeitado',
      'VALIDMAIL_9': 'Ativar edição para a empresa',
      'VALIDMAIL_10': 'Deseja ativar a edição de email para a empresa novamente?',
      'VALIDMAIL_11': 'A edição foi habilitada para a empresa',
      'VALIDMAIL_12': 'Editar correio',
      'VALIDMAIL_13': 'Agora você pode editar o email enviado pela empresa',
      'SINCORREOS': 'Não há e-mails para validar',
      'FILEMANODS': 'Gerenciador de arquivos',
      'TEX-MENS-1':'A Empresa',
      'TEX-MENS-2':'nenhum utilizador',
      'FILEMAN_PRIV': 'Pasta privada',
      'FILEMAN_PUB': 'Pasta pública',
      'USUARIO':'Usuario',
      'AL':'al',
      'SEN_EMAIL_REQ': 'Gostaria de enviar o email de requisitos técnicos',
      'SEN_EMAIL_REQ_PROD':' Certifique-se de enviar o e-mail de requisitos técnicos ',
      'ETIQUE_SEN_EMAIL_REQ_PROD':' Requisitos técnicos para correspondência ',
      'EMAIL_REQ_PLACE': 'Seleccione uma língua',
      'EMAIL_REQ_INTRO':'Seleccione uma língua para continuar',
      'WARN_SEN_EMAIL_REQ_PROD': 'Para continuar deve seleccionar uma língua',
      'TOOLTI_SEN_EMA':' Enviar e-mail ',
      'ESTA_EMA_TRUE':' * Correio enviado ',
      'ESTA_EMA_FALSE':' * Correio não enviado ',
      'SEN_EMAIL_MODAL': 'Enviando e-mail ......',
      'RTINFO': 'Informações de requisitos técnicos',
      'TOOTI_RES_EMPR':'Resultados empresariando',
      'WARNI_SELCT_CHECK':'Para continuar com a pesquisa é obrigatório verificar pelo menos uma caixa',
      'REQ':{
        'BTNSI':'Sim',
        'BTNNO':'Não',

        'MENSAJE1':'Quer desativar os requisitos técnicos?',
        'MENSAJE2':'Deseja ativar os requisitos técnicos?',
      },
      'EDITORMAILODS': {
        'OPCION_1': 'Ativar o editor de email para este produto',
        'OPCION_2': 'Validação automática de alterações',
        'OPCION_3': 'Ative os detalhes dos requisitos no processo de pesquisa',
        'OPCION_4': 'Ative a validação da pesquisa para a Área de Foco',
        'OPCION_5': 'Permitir a alteração do tempo de aplicação',
        'OPCION_6': 'Permitir extensões',
        'OPCION_7':'Chance de sucesso nos detalhes dos requisitos no processo de pesquisa',
        'OPCION_8': 'Número de lembretes atribuíveis',
        'OPCION_9': 'Ativar edição da data de fechamento',
        'OPCION_11_ENTREGABLES': 'Mostrar resultados de entregas no Portal de Contagem',
        'OPCION_11_RANKING': 'Mostrar resultados de certificação e classificação no Portal de contagem',
        'OPCION_12':'Ativar proteção de pesquisa com PINs de usuário',
        'OPCION_13':'Habilite a pergunta de validação aleatória',
        'OPCION_14': 'Mostrar caixa de instruções no aplicativo de pesquisa',
        'OPCION_15': 'Mostrar caixa de suporte no aplicativo de pesquisa',
        'OPCION_16': 'Mostrar nome de usuário no aplicativo de pesquisa',
        'MODAL_OP1_ON': 'O editor de email deste produto foi ativado',
        'MODAL_OP1_OFF': 'O editor de email deste produto foi desativado',
        'MODAL_OP2_ON': 'A validação automática de alterações foi ativada para este produto',
        'MODAL_OP2_OFF': 'A validação automática de alterações para este produto foi desativada',
        'MODAL_OP6_ON': 'Permitir o rollover para este produto foi habilitado',
        'MODAL_OP6_OFF': 'Permitir o rollover para este produto foi desativado',
        'MODAL_OP7_ON': 'O número de lembretes atribuíveis para este produto foi alterado',
        'MODAL_OP8_ON': 'A edição da data de encerramento da pesquisa foi ativada para este produto',
        'MODAL_OP8_OFF': 'A edição da data de fechamento da pesquisa para este produto foi desativada',
        'MODAL_OP11_ENTREGABLES_ON': 'A amostra de resultados entregáveis foi activada ',
        'MODAL_OP11_ENTREGABLES_OFF': 'A amostra de resultados entregáveis foi desactivada',
        'MODAL_OP11_RANKING_ON': 'Amostra de certificação e resultados de classificação activados',
        'MODAL_OP11_RANKING_OFF': 'A amostra de resultados de certificação e classificação foi desactivada',
        'MODAL_PIN_ON':'Pin está habilitado',
        'MODAL_PIN_OFF':'Pin está desativado',
        'MODAL_PRECONTROL_ON':'A pergunta de validação aleatória foi ativada',
        'MODAL_PRECONTROL_OFF':'A pergunta de validação aleatória está desativada',
        'MODAL_OP14_ON ':' Mostrar a caixa de instrução no aplicativo de pesquisa está ativa ',
        'MODAL_OP14_OFF ':' A exibição da caixa de instrução no aplicativo de pesquisa está desativada ',
        'MODAL_OP15_ON ':' Mostrar painel de suporte no aplicativo de pesquisa foi ativado ',
        'MODAL_OP15_OFF ':' Mostrar caixa de suporte no aplicativo de pesquisa desativado ',
        'MODAL_OP16_ON ':' A exibição do nome do usuário no aplicativo de pesquisa está ativa ',
        'MODAL_OP16_OFF ':' A exibição do nome do usuário no aplicativo de pesquisa está desabilitada ',
        'TITUOPTS': 'Opções',
        'TITUCORRS': 'E-mails restantes para validar',
        'SELLANG': 'Selecione um idioma da lista para visualizar o email',
        'SELLANG_L': 'Selecione um idioma',
        'ASUNTO': 'Assunto do correio',
        'ASUNTOPILOTO': 'Assunto do correio piloto',
        'WAIT':'Salvando mudança',
        'ULTD': 'Ilimitado',
        'CLOUD_LEGACY': 'Ative a versão atualizada do gerenciador de arquivos',
        'CUSTOM_TEXT_CERT': 'Ative o texto do certificado multi-site',
        'CUSTOM_TEXT_CERT_EDIT': 'Edite o texto do certificado',
        'TEXT_SECC_CONF_VOIC': 'Mostrar secção de configuração de voz',
        'SAVED_CHANGES': 'A mudança foi salva com sucesso',
        'CUSTOM_TEXT': {
          'TITULO': 'Liste os países onde o certificado multi-site tem cobertura',
          'SUBTITULO': 'Escreva o novo texto',
          'SUBTITULO2': 'Atenção, se você alterar o texto e clicar no botão OK, o texto atual será sobrescrito',
          'HINT': 'Texto do certificado',
          'OK': 'Aceitar',
          'CANCEL': 'Cancelar',
          'SAVED_CHANGES': 'O texto foi salvo corretamente',
          'CURRENT_T1': 'Texto atual de vários sites',
          'CURRENT_T2': 'O texto multi-site atual é muito longo, para visualizá-lo clique no botão Editar',
        }
      },
      'ASOCIARCERTIFICAR':{
        'CHECK':'Associar auditoria de cultura a um certificado',
        'INPUT':'Certificado a ser associado',
        'INPUT_2':'Produto a associar',
        'CERTIFICAR':'Certificar',
        'MEDIR':'Medida',
      },
      'LOG_SENDGRIND':{
        'TITULO':'Log SendGrid',
        'OPCION':'Selecione uma opção:',
        'TOOLTIP':'Status de pesquisa',
        'TABLA':{
          'USUARIO':'Do utilizador',
          'EMAIL':'Email',
          'ASUNTO':'Caso',
          'ESTATUS':'Status'
        },
        'DIALOG_SENDGRIND':{
          'TITTULO':'Informação de correio',
          'TO':'Para',
          'FROM':'De',
          'SUBJECT':'Caso',
          'HISTORIAL':'Histórico de correio',
          'ESTATUS':'Estado',
          'ABIERTO':'Horários de abertura:',
          'ULTIMO_EVENTO':'Último evento:',
          'SIN_CORREOS':'Seu histórico de e-mail não está disponível!',
          'BOTON':'Fechar',
          'NOTE':'NOTA: A data / hora exibida na lista é definida para a hora local do  ',
        },
      },
      'CONFIR_CAMBIOS_SECCION':'Atualmente a pesquisa já está criada,\n\n você tem certeza de que quer fazer as mudanças? \n\n Se você confirmar, gere a pesquisa novamente',
      'MODAL_CAMBIOS_SECCION':'Atualização das seções',
      'TIT_MOD_AGRE_ENCU': 'Novo processo de pesquisa',
      'TEX_NAM_SUR': 'Nome da pesquisa:',
      'TEX_PLA_SUR': 'Seleção do modelo',
      'BTN_AGRE_SUR':'Adicionar',
      'PLA_TEX_NAM_SUR': 'Nome da pesquisa:',
      'PLA_TEX_PLA_SUR': 'Seleção do modelo',
      'WARNI_NOT_SURV_NOM35':'A pesquisa atualmente não é gerada',
      'MODAL_CREAT_INFRA':'A infra-estrutura está a ser criada, aguarde',
      'MODAL_ERROR_INFRA':'Ocorreu um erro ao criar a infra-estrutura',

    },
    'GESTORSTATUS': {
      'BOTACCESO': 'Informação sobre o produto',
      'TITULO': 'Produtos comprados',
      'PRODUCTOS':{
        'CERTIFICAR': 'Certifique',
        'MEDIR': 'Medida',
        'PULSE': 'Pulse Check',
        'FOCUS': 'Focus Area',
        'NUMPROD': 'Número de produtos: ',
        'BOTACCESO': 'Ver produtos',
        'NOPRODUCTOS': 'Nenhum produto comprado'
      },
      'PRODSINFO': {
        'ADQUIRIDOS': 'Produtos comprados',
        'SELECCIONE': 'Seleccione um produto da lista para ver a sua informação'
      },
      'STATUS': {
        'LISTA': 'Lista de passos',
        'CURRENT': 'Estado da passagem',
        'INFO': 'Esta lista mostra o estado actual de cada etapa do processo de certificação.\n\nPode alterar o estado de um passo concluído para "Não concluído" clicando no selector de estado.\n\nNota: Alguns estados só podem ser alterados sob certas condições.',
        'NO': 'Não Completado',
        'SI': 'Etapa concluída',
        'TOOLTIP': {
          'HELP': 'Clique para saber mais',
          'SLIDER': 'Clique aqui para alterar o estado desta etapa'
        }
      }
    },
    'ALERTS': {
      'OK': 'OK',
      'ODSINSERTOK': 'A empresa foi registada correctamente',
      'ODSFAILINSERT': 'O processo de registo falhou, por favor tente novamente',
      'COLPLETEFORM1': 'Por favor, complete o passo 1',
      'COLPLETEFORM2': 'Por favor, complete o passo 2',
      'COLPLETEFORM3': 'Por favor, complete o passo 3',
      'COLPLETEFORM4': 'Por favor, complete o passo 4',
      'COLPLETEFORM5': 'Por favor, complete o passo 5',
      'ODSEXIST': 'A empresa já está registada no sistema. A informação não foi armazenada',
      'MAIL':'Quer enviar o correio de volta para as diferentes pessoas responsáveis?',
      'RSPSI':'Sim',
      'RSPNO':'Não',
      'LABEL01':'Já tem um produto NOM 035 atribuído',
      'FIELD':'A ligação de acesso ainda não foi introduzida.',
      'PASSWORD': {
        'LONGITUD': 'A senha deve ter pelo menos oito caracteres',
        'MINUSCULAS': 'A senha deve ter pelo menos uma letra minúscula',
        'MAYUSCULAS': 'A senha deve ter pelo menos uma letra maiúscula',
        'NUMEROS': 'A senha deve ter pelo menos um caractere numérico',
        'ESPCHARS': 'A senha deve ter pelo menos um caractere especial, não alfanumérico',
        'VALIDACION': 'Ocorreu um problema ao validar a senha, digite-a novamente e tente criar o usuário novamente'
      }
    },
    'TI_MANAGER': {
      'TITULO': 'Gestor de TI',
      'DESCRIPTION': 'Introduzir os dados do gestor de TI para enviar as informações e configurações necessárias a serem executadas antes da aplicação do inquérito',
      'DATOS': 'Dados',
      'NOMBRE': 'Nome: ',
      'APELLIDOS': 'Apelido: ',
      'EMAIL': 'Endereço de correio electrónico:',
      'TELEFONO': 'Telefone: ',
      'EXTENSION': 'Extensão: ',
      'CELULAR': 'Celular: ',
    },
    'PERFILES': {
      'CABECERA':{
        'TITULO': 'CRIADOR DO PERFIL',
        'DESCRIP': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit,'
      },
      'BOTONES':{
        'BOT1':{
          'TITULO': 'Perfil da empresa',
          'BOTON': 'Criar'
        },
        'BOT2':{
          'TITULO': 'Perfil do utilizador',
          'BOTON': 'Admin'
        },
        'BACK': 'Voltar a',
        'NEXT': 'Próximo',
        'RESET': 'Reiniciar',
        'EDIT': 'Salve '
      },
      'EMPRESA':{
        'WAIT': 'Aguarde por...',
        'TITUHEAD': 'Perfil da empresa',
        'CLOUD': 'Pasta privada',
        'INFO': 'Criar o perfil de uma empresa',
        'INFOMOD': 'Você pode modificar os dados do perfil desta empresa <b>(as alterações são salvas automaticamente)</b>',
        'PDF':{
          'BOTONDESCARGA':'Descarregar informação em pdf',
          'FECHA':'Data: ',
          'HORA':'Hora: ',
          'MODAL':'Geração de ficheiro para download...',
        },

        'ACTUALIZARCA':{
          'ACTUALIZARCA':'Actualização Culture Audit',
          'ACTUALIZARCA_BRI':'Actualização do Resumo da Cultura',
          'ACTUALIZARCA_ACTIAN':'Atualizar plano de ação',
          'CERRAR':'Fechar',
          'SUCCESS':'Culture Audit actualizado com sucesso',
          'SUCCESS_ACTION':'Plano de ação actualizado com sucesso',
          'ERROR':'Erro, a sua Auditoria de Cultura não tem um produto certificado',
          'ERROR_ACTION':'Erro, a sua Plano de ação não tem um produto certificado',
        },

        'SECCIONES':{
          'SEC1': {
            'TITULO': 'Informação sobre a empresa',
            'TITULOPDF': 'Informação sobre a empresa ',
            'NOMEMP': 'Nome da empresa: ',
            'NOM': 'Nome: ',
            'SECTORREQUIRED': 'O sector é necessário',
            'SUBSECTORREQUIRED': 'O subsector é necessário',
            'ANIOFU': 'Ano de fundação ',
            'INSTITUTO': 'Instituto ',
            'SALESFORCE': 'Identificação do cliente ',
            'CODE': 'Código do projecto ',
            'SALES_REQUIRED': 'É necessária a identificação do cliente',
            'CODE_REQUIRED': 'O código do projecto é necessário',
            'INSTITUTO_REQUIRED': 'O instituto é necessário',
            'COMPANY': 'Empresa ',
            'COMPANY_REQUIRED': 'O nome da empresa é obrigatório',
            'CAMPO_INVALID': 'O campo não permite os seguintes caracteres /*?"<>:\'',
            'COMPANY_ACOR': 'Nome curto da empresa',
            'MOD_INGRE_ACORT': 'Para continuar digitando o nome curto da empresa',
            'ACORT_REQUIRED': 'Nome curto da empresa é obrigatório',
            'SEDE': 'País anfitrião',
            'SEDE_REQUIRED': 'É necessário selecionar o país anfitrião para continuar',
            'PUBLICATION': 'Nome da empresa para publicação ',
            'PUBLICATION_REQUIRED': 'O nome da empresa para a publicação é obrigatório',
            'FUNDATION': 'Ano de fundação ',
            'FUNDATION_REQUIRED': 'O ano de fundação da empresa é necessário',
            'EMP_TC_REQUIRED': 'O número de empregados a tempo inteiro é necessário',
            'EMP_TP_REQUIRED': 'Por favor complete o número de empregados a tempo parcial',
            'TOTCOL_REQUIRED': 'Por favor, complete o número total de colaboradores',
            'RANKING': 'Ranking ',
            'RANKING_REQUIRED': 'Por favor, seleccione a classificação',
            'TIPO': 'Gama de colaboradores ',
            'TIPO_REQUIRED': 'Por favor seleccione uma gama',
            'MULTINACIONAL': 'Multinacional ',
            'MULTINACIONAL_REQUIRED': 'Por favor seleccione se é uma multinacional',
            'ANIORANK_REQUIRED': 'Introduzir o ano de classificação',
            'REGION': 'Região ',
            'REGION_REQUIRED': 'Entre na sua região',
            'PAIS': 'País',
            'ESTADO': 'Estado, cidade ou província',
            'NAM_RANKIN': 'Nome do Ranking',
            'TYP_RANKIN': 'Classificação do tipo',

            'OPTSI': 'Sim',
            'OPTNO': 'Não',

            'EMP_TC': 'Empregados a tempo inteiro ',
            'EMP_TP': 'Empregados a tempo parcial ',
            'TOTCOL': 'Número total de colaboradores ',
            'ANIORANK': 'Ano de classificação ',
            'ETIQ_CATALOGOS':{
              'SECTOR': 'Seleccione um sector',
              'SUBSECTOR': 'Seleccione um subsector',
              'MULTIN': 'Multinacional',
              'TIPO': 'Tipo (categoria ou sector).',
              'REGION': 'Seleccione uma região.'
            },
            'CATALOGOS':{
              'INSTITUTOS': catalogos.institutos,
              'SECTORES': catalogos.sectores,
              'RANKING': catalogos.ranking,
              'REGIONES': catalogos.regiones,
            }
          },
          'SEC2': {
            'TITULO': 'Gestor de projecto',
            'NOM': 'Nome ',
            'APE': 'Apelido ',
            'EMAIL': 'Endereço de correio electrónico ',
            'TEL': 'Telefone ',
            'EXT': 'Extensão ',
            'CEL': 'Celular ',

            'NOM_REQUIRED': 'Introduza um nome',
            'APE_REQUIRED': 'Digite o seu apelido',
            'EMAIL_REQUIRED': 'Introduza o seu endereço de correio electrónico',
            'TEL_REQUIRED': 'Introduza o seu telefone',
            'EXT_REQUIRED': 'Introduzir uma extensão',
            'CEL_REQUIRED': 'Introduza o seu telemóvel'

          },
          'SEC3': {
            'TITULO': 'Director de Recursos Humanos',
            'NOM': 'Nome completo ',
            'EMAIL': 'Endereço de correio electrónico ',
            'TEL': 'Telefone ',
            'EXT': 'Extensão ',
            'CEL': 'Celular ',

            'NOM_REQUIRED': 'Introduza um nome',
            'EMAIL_REQUIRED': 'Introduza o seu endereço de correio electrónico',
            'TEL_REQUIRED': 'Introduza o seu telefone',
            'EXT_REQUIRED': 'Introduzir uma extensão',
            'CEL_REQUIRED': 'Introduza o seu telemóvel'

          },
          'SEC4': {
            'TITULO': 'Gestor de TI',
            'NOM': 'Nome completo ',
            'EMAIL': 'Endereço de correio electrónico ',
            'TEL': 'Telefone ',
            'EXT': 'Extensão ',
            'CEL': 'Celular ',
            'REGISTER': 'Registe-se',

            'NOM_REQUIRED': 'Introduza um nome',
            'EMAIL_REQUIRED': 'Introduza o seu endereço de correio electrónico',
            'TEL_REQUIRED': 'Introduza o seu telefone',
            'EXT_REQUIRED': 'Introduzir uma extensão',
            'CEL_REQUIRED': 'Introduza o seu telemóvel'
          },
          'SEC5': {
            'TITULO': 'Produtos a entregar:',
            'ENTRE': 'Entregue em:',
            'TIPO': 'Tipo:',

            'ENTRE_REQUIRED': 'Introduza o produto a entregar:',
          }
        },
        'MENSAJES':{
          'CARGABD': 'Carregar base de dados',
          'STATUS': 'ESTADO',
          'CORRECTO': 'O perfil da empresa foi criado correctamente',
          'ERROR': 'Ocorreu um erro durante a criação do perfil da empresa'
        }
      },
      'USUARIO':{
        'TITULO_LOGIN':'Selecione o usuário com o qual deseja fazer o login',
        'MJS_COMPLETE_INFO': 'Preencha por favor a informação',
        'MSJ_INVALIDEMAIL': 'Por favor introduza um endereço de correio electrónico válido',
        'MSJ_SELECTCOMPANY': 'Por favor seleccione uma empresa',
        'REGISTER_SUCCESS': 'Utilizador registado com sucesso',
        'REGISTER_SUCCESS_SWIFT': 'Utilizador registado com sucesso, foi enviado um e-mail ao seu utilizador para activação',
        'REGISTER_ERROR': 'Erro, o utilizador não pôde registar-se, por favor tente novamente',
        'PRODUCT_REGISTEROK': 'Produto correctamente registado',
        'PRODUCT_REGISTERPREVIOUS': 'Produto previamente registado',
        'PRODUCT_REGISTERFAIL': 'Erro durante o registo do produto, tente novamente',
        'CERTIFICAR_EXISTENTE': 'O produto certificado já existe',
        'CERTIFICAR_NO_TERMINADO': 'Para acrescentar o seguinte produto deve concluir com o certificado do ano',
        'CERTIFICAR_NO_EXISTENTE': 'Para adicionar o Produto Pulsecheck deve adquirir o certificado para o ano',
        'PULSOS-COMPLETOS':'Actualmente tem os pulsos permitidos',
        'MSJ_SELECTYEAR': 'Por favor seleccione um ano',
        'MSJ_SELECTPRODUCT': 'Por favor, seleccione um produto',
        'MSJ_SELECTTEMPLETE': 'Por favor seleccione um modelo',
        'SIN_USUARIO': 'É necessário registar um utilizador a esta empresa para poder adicionar este produto',
        //'SIN_SURVEYTOKEN': 'É necessário introduzir a chave do inquérito para ser associado a este produto, a fim de o atribuir',
        'MISMOANIOCERTIFICAR': 'O produto não pode ser adicionado, você já tem um produto Certificar do mesmo ano, selecione um ano diferente e tente novamente',
        'SIN_SURVEYTOKEN': 'O ano deste produto ainda não tem levantamento',
        'SIN_CERTIFICAR_ASOCIA': 'Você ainda precisa associar um produto certificado',
        'SIN_TABLEAUVER': 'É necessário introduzir a versão dos resultados a associar a este produto a fim de o atribuir',
        'SINRANKING': 'Você precisa selecionar o ano de classificação para este produto antes de continuar',
        'SINTIPORANK': 'Você precisa selecionar o tipo de classificação para este produto antes de continuar',
        'SINIDOPORTUNITY': 'Você precisa inserir o ID da oportunidade para este produto antes de continuar',
        'SINNAMEOPORTUNIDADE': 'É necessário introduzir o nome de oportunidade para este produto antes de prosseguir',
        'SINIDTYPERESULT': 'É necessário introduzir o tipo de resultado para este produto antes de continuar',
        'SINPROYECTMANAGER': 'Você precisa inserir o nome do gerente de projeto deste produto antes de continuar',
        'SINCORREOPM': 'Você precisa inserir o e-mail do gerente de projeto deste produto antes de continuar',
        'EMAILNOVALIDO': 'O e-mail do gerente de projeto inserido não está no formato válido, verifique-o e insira-o novamente',
        'GUARDANDOPRODUCTO': 'O produto selecionado está sendo adicionado à empresa, aguarde um momento',
        'TOKENMODAL_1': 'Este é o token de pesquisa do produto recém-adicionado',
        'TOKENMODAL_2': 'o que você quer fazer depois?',
        'TOKEN_SI': 'Copie o token',
        'TOKEN_NO': 'Prosseguir',
        'TOKEN_COPIADO': 'O token da pesquisa foi copiado para a área de transferência com sucesso',
        'ERROR1':'Já tem um produto registado este ano',
        'TITUHEAD': 'Perfil do utilizador',
        'TITUCREARHEAD': 'Criar usuário',
        'TITUBUSCARHEAD': 'Pesquisar usuário',
        'TITUBUSCAREMPRESA': 'Pesquisar empresa',
        'TITUUSERGPTWHEAD': 'Usuários Admin',
        'TH-NOMEMPRE':'Nome da empresa',
        'TH-USUARIO':'Usuário',
        'TH-TUSUARIO':'Tipo de usuário',
        'TH-ACCIONES':'Ações',
        'TH-LOGIN':'Conecte-se',
        'TH-INSTITUTO':'Instituto',
        'ACC-DELET':'Excluir usuário',
        'ACC-EDIT':'Editar Usuário',
        'UPDATE-USER':'Actualizado correctamente',
        'EXIST-USER':'Usuário existente',
        'ALERT-EDIT':'Você tem certeza de que vai modificar o usuário?',
        'USUARIO-T':'Usuários',
        'CONFIRM_ELIMINAR_USU':'Tem certeza de que deseja excluir o usuário?',
        'INGR_ELIMINAR_USU':'<span>Insira o usuário marcado em vermelho no campo de texto ',
        'INGR_ELIMINAR_USU.2':'</span>',
        'ERROR_ELIMINAR_USU':'O usuário inserido não corresponde',
        'OK_ELIMINAR_USU':'O usuário foi excluído corretamente',
        'PASSWORDSAFE': 'A senha deve ter pelo menos 8 caracteres: pelo menos 1 dígito, pelo menos 1 letra minúscula, pelo menos 1 MAIÚSCULAS e pelo menos 1 caractere não alfanumérico',
        'PRODUCT_EXIST': 'O produto com data seleccionada já existe',
        'WAR_ADD_NA_US':'Por favor, introduza o nome de utilizador',
        'WAR_ADD_TOT_US':'Por favor, introduza o número total de colaboradores',
        'WAR_ADD_EMA_US':'Por favor, introduza o e-mail do utilizador',
        'WAR_ADD_PASS_US': 'Por favor introduza a palavra-passe do utilizador',
        'WAR_INCO_EMA_US': 'O e-mail introduzido está incorrecto',
        'WAR_INCO_PASS_US': 'A palavra-passe não está no formato permitido',
        'MOD_SAV_US': 'Utilizador salvador',
        'INFO': 'Perfil para um usuário',
        'USUARIO': 'Endereço de correio electrónico: ',
        'USE_NAM': 'Nome de utilizador',
        'USUARIO_REQUIRED': 'O e-mail é necessário',
        'CONTRA_REQUIRED': 'É necessária uma palavra-passe',
        'LEVEL_REQUIRED': 'Por favor seleccione um nível',
        'COMPANY_REQUIRED': 'Por favor seleccione uma empresa',

        'USUARIOREQUIRED': 'O e-mail é necessário',
        'USUARIONAMEREQUIRED': 'Username is required',
        'CONTRAREQUIRED': 'É necessária uma palavra-passe',
        'LEVELREQUIRED': 'Por favor seleccione um nível',
        'CONTRA': 'Senha: ',
        'COMPANY': 'Empresa: ',
        'NIVEL': 'Nível: ',
        'NIVELES': catalogos.niveles,
        'GUARDA': 'Salve',
        'MENSAJES':{
          'CARGABD': 'Carregar base de dados',
          'STATUS': 'ESTADO',
          'CORRECTO': 'O perfil do utilizador foi criado correctamente',
          'ERROR': 'Ocorreu um erro durante a criação do perfil do utilizador'
        }
      }
    },
    'CONSULTARENCUESTA':{
      'TITULO':'Consultar inquérito',
      'HEADER':'Seleccione o instituto',
      'INSTITUTOS':'Institutos',
      'FILTRO':'Filtro',
      'FILTRO_EMPRESA':'Empresa de filtros:',
      'FILTRO_TI_EMPR_TOKEN':'Pesquisa simbólica de filtro / tipo de empresa:',
      'SELECCIONFILTRO':'Encontrar a informação necessária',
      'BOTON_DESCARGA_EXCEL':'Descarregar informação em formato excel',

      'CARGANDO':'Carregamento de informação...',
      'NOMBRE_DE_EMPRESA':'Nome da empresa',
      'TIPO_DE_EMPRESA':'Tipo de empresa',
      'FECHA_C':'Data de criação',
      'SECTOR':'Sector',
      'SUBSECTOR':'Subsector',
      'TIPO_ENC':'Tipo de inquérito',
      'PLANTILLA':'Modelo',
      'CATALOGOSPRODUCTOS': catalogos.plantillas,
      'TOKEN':'Survey token',
      'ID_ENC':'Identificação do inquérito',
      'ANIO':'Año',
      'CORREOS_EN':'Correspondência enviada',
      'FECHA_A':'Data de aplicação',
      'FECHA_CR':'Data de encerramento',

      'MODAL_SUCCES':'Ficheiro descarregado com sucesso',
      'MODAL_WARNING':'Não seleccionou nenhum instituto',

      'MEXICO':'México',
      'CENTROAMERICAYELCARIBE':'América Central e Caraíbas',
      'CHINAYHK':'A China e a Grande China',
      'FILIPINAS':'Filipinas',
      'SINGAPUR':'Singapura',
      'TURQUIA':'Turquia',
      'VIZUENCU':'Pesquisas de visualização',
      'SELE_AN_ENCU':'Seleccione un año',


    },
    'CONSULTAR_RT':{
      'TITULO':'Consulte os requisitos técnicos',
      'HEADER': 'Selecione o instituto',
      'INSTITUTOS': 'Institutos',
      'FILTRO': 'Filtro',
      'SELECCIONFILTRO':'Procure a empresa necessária',
      'CARGANDO':'Carregando informação...',
      'NOMBRE_DE_EMPRESA':'nome da empresa',
      'FECHA_DE_EMPRESA':'Data de criação',
      'PRODUCTO':'Tipo de Produto',
      'TOKEN': 'Ficha de pesquisa',
      'ESTATUS': 'Status',
      '0':'Não iniciado',
      '1': 'Em processo',
      '2': 'Acabado',
      'ACCIONES':'Ações',
      'PRODUCTOS':catalogos.productos,
      'ELEMENTOS':'itens por página',
      'DE':'de',
      'SIGUIENTE':'Próximo',
      'ULTIMA':'Última página',
      'PRIMERA':'Primeira página',
      'ANTERIOR':'Anterior'

    },
    'PAQUETES':{
      'NOMBRES':{
        '1': 'Pacote SILVER',
        '2': 'Pacote OURO',
        '3': 'Pacote PLATINA',
      },
      'TOOLTIP':{
        'CONFIG': 'Clique para configurar',

      },
      'MENSAJES': {
        'ADDOK': 'O pacote foi adicionado à empresa correctamente. Abaixo pode configurar os produtos do pacote seleccionado',
        'NOTOK': 'O pacote não pôde ser adicionado, já existe um pacote atribuído ao ano especificado, tente novamente, escolhendo outra opção',
        'USURE_PROD': 'Confirma a configuração deste produto com as características escolhidas?',
        'PROD_ACTIVADO': 'Este produto já está activado',
        'ONLYONE': 'Nesta categoria só se pode escolher um tipo de produto. Quer continuar o processo com esta escolha?',
        'NOYEAR': 'Não seleccionou o ano de candidatura para o pacote',
        'NOPAQ': 'Não seleccionou o pacote a ser atribuído',
      },
      'PREVIO':{
        'INFO': 'Não tem um pacote de produtos actual',
        'BOTONES':{
          'ADD': 'Adicionar um pacote',
          'SEE': 'Consultar um pacote anterior',
          'CANCELAR': 'Cancelar',
          'ADDPACK': 'Adicionar pacote',
          'SI': 'Sim',
          'NO': 'Não',
        },
        'STEPS': {
          '1': 'Seleccione o pacote que pretende atribuir à empresa',
          '2': 'Seleccionar o ano de candidatura para o pacote',
        }
      },
      'INFOPAQ':{
        'TITULO': 'Pacote actual:',
        'APLICA': 'Ano de aplicação:',
        'AVANCE': 'Pré-visualização da configuração da embalagem',
        'STATUS':{
          'TITULO': 'Estado:',
          'OK_1': 'Configuração completa',
          'NOTOK_1': 'Configuração incompleta',
          'OK_2': 'Activação total',
          'NOTOK_2': 'Não activado',
          'ADICIONAL': 'Produtos adicionais',
          'ADINFO': 'Nota: A adição é opcional',
        },
        'BOTONES':{
          'ADD': 'Adicionar produto',
          'CANCELAR': 'Cancelar',
          'SI': 'Sim',
          'NO': 'Não',
          'BACK': 'Voltar a',
          'ADDONE': 'Adicionar um produto',
          'DETAIL': 'Ver detalhes',
        },
        'CERTIFICAR':{
          'TITULO':{
            '1': 'Não activou este produto',
            '2': 'Já activou este produto',
            '3': 'Esta é uma categoria, pode activar os seguintes produtos:',
            '4': 'Este produto pode ser atribuído mais de uma vez durante a vida da embalagem',
          },
          'INSTRUC': 'Configure este produto abaixo',
          'TIPO': 'Seleccione o tipo de produto',
          'INFO':{
            'TITULO': 'Dados do produto',
            'SECCIONES': 'Secções',
            'TIPO': 'Tipo',
            'TEMP': 'Modelo seleccionado',
            'STATUS':{
              'TITULO': 'Estado actual',
              '1': 'Ainda não terminado',
              '2': 'Concluído',
            },
            'TABLA':{
              '1': 'Produto',
              '2': 'Opções'
            }
          }
        }
      }
    },
    'AUDITORIA-AUTOMATICA':{
      'TITULO': 'Auditoria Automatizada',
      'TABLA':{
        'TH-NOM-EMPRESA':'Nome da empresa',
        'TH-NO-COLAB':'N.º Colaboradores',
        'TH-CONTESTADOS':'Respondido',
        'TH-FALTANTES':'Falta',
        'TH-PROGRESO':'Progresso',
        'TH-ACCIONES':'Acções',
        'MSJ-DETALLES':'Ver detalhes',
      }

    },
    'RESULTA-AUDITO':{
      'TIEM-RES-TAB':'Tempo de resposta dos colaboradores',
      'RES-CONT-TAB':'Respostas de controlo',
      'RES-COMENT-TAB':'Respostas aos comentários',
      'TIEM-RES-TITULO':'Verificar o tempo de resposta dos colaboradores',
      'RES-CONT-TITULO':'Percentagem de respostas a perguntas de controlo',
      'RES-COMENT-TITULO':'Percentagem de comentários que estão vazios, repetidos ou que contêm caracteres repetidos',
      'RES-AGREGAR': 'Adicionar uma amostra',
      'RES-SELECCIONAR': 'Seleccionar amostra',
      'RES-TEXTO1': 'Ainda não foi criada nenhuma amostra',
      'RES-TEXTO2': 'Por favor, seleccione uma amostra para ver os dados',
      'INGRE-NOM': 'Introduza o nome da amostra',
      'SELEC-REG': 'Seleccionar as regras da amostra',
      'REGLAS':{
        '1': 'Colaboradores que responderam em menos de 10 minutos',
        '2': 'Colaboradores que responderam a todos os seus itens com um valor de 5',
        '3': 'Colaboradores que responderam SIM à pergunta de controle',
        '4': 'Colaboradores que responderam a uma pergunta aleatória de forma incorreta',
        '5': 'Colaboradores que mudaram mais de 10 respostas',
      },

      'TABLA':{
        'TITULO': 'Dados dos colaboradores na amostra',
        'NOMBRE': 'Nome',
        'TELEFONO': 'Telefone',
        'CELULAR': 'Celular',
        'CORREO': 'Endereço de correio electrónico',
        'COMENTÁRIO': 'Comentário',
      },
      'MODALES':{
        'GENERANDO': 'Gerar amostra, por favor aguarde...',
        'GUARDANDO': 'Comentário de poupança, por favor aguarde...',
        'TITULO': 'Comentário guardado',
        'CERRAR': 'Fechar',
        'TITULO_INFORMACION': 'Uma vez adicionado o comentário, o campo não pode permanecer vazio, os últimos dados nele guardados serão tomados',
        'SUCCE-MUES': 'se creo correctamente la muestra',
        'WARNI-SINU': 'Ya no quedan usuarios para registrar',
        'WARNI-CONDI': 'Não se esqueça de colocar um nome e seleccionar pelo menos uma regra',


      },
    },
    'DESCARGAR_ENCUESTA':{
      'NPS':'NPS',
      'REACTIVOS':'Reagentes',
      'CONTROL':'Controlo',
      'DEMOGRAFICOS':'Demográficos',
      'ABIERTAS':'Aberto',
      'CA':'4ALL',
      'CODIGOPROYECTO':'Código do projecto: ',
      'ANIOAPLICACION':'Ano de aplicação: ',
      'MENSAJE':'Não é possível descarregar o inquérito, porque este ainda não foi criado',
      'ACEPTAR':'Aceitar',
      'TEXTODESCARGA':'Levantamento de ',
      'DESCARGARENCUESTA':'Descarregar inquérito',
      'INFORMACIONYAVISO':'Informação de inquéritos e aviso de privacidade',
      'SECCIONES':'Seções',
      'MODAL':{
        'TITLE':'Lista de línguas',
        'SUBTITLE':'Selecione um idioma',
        'PLACEHOLDER':'Nenhum',
        'BTNCLOSE':'Fechar',
        'BTNSELECT':'Baixar'
      }
    },
    'INFORT': {
      'TITULO': 'Voortgang technische vereisten',
      'SINLANGS': 'Você precisa selecionar os idiomas neste produto para ver a lista de etapas',
      'PASOS': {
        'PASO_1': 'Stappenlijst',
        'PASO_2': 'Vragenlijst',
        'PASO_3': 'Vermelding'
      },
      'LISTAPASOS': {
        'autentication': 'Enquête-authenticatie',
        'testAccess': 'Weergavetest',
        'testEmail': 'Bewijs van e-mailontvangst',
        'validationQ': 'Validatievragenlijst',
        'requirements': 'Beleid inzake gegevensbescherming',
      },
      'STATUS': {
        'PEND': 'In afwachting',
        'DONE': 'Stap voltooid',
      },
      'RESP': 'Antwoord verzonden',
      'NORESP': 'Onbeantwoord'
    },
    'MODAL_CONSULT_INFRAESTRU':{
      'TITL':'Infra-estrutura dedicada:',
      'INSTRUC_1':'Deseja acrescentar uma infra-estrutura dedicada?',
      'LAB_SUBDOMINIO':'Subdomínio',
      'WARN_CARACT': 'O campo não permite a letra ñ, letras maiúsculas e caracteres especiais',
      'BTN_CONTI': 'Continuar',
      'SI': 'Sim',
      'NO':'Não',
      'MODA_IMPORT_SUBDOM':'Para continuar, tem de introduzir o subdomínio',
    }
  }
};
